
<template>
    <div class="customervendor-container">
        <ThatsTable title="Showrooms Setup" ref="table" :endpoint="endpoint" @openModal="openWindow" @deleteYes="DispatchDelete" @openUpdateModal="OpenUpdateModal" :columns="columns"></ThatsTable>
        <ShowroomsForm ref="dialogForm" @success="refreshTable" @delete="formDelete"></ShowroomsForm>
    </div>
</template>
<script>
import { mapGetters, mapMutations,mapActions } from 'vuex';
import ShowroomsForm from './ShowroomsForm'
import ThatsTable from '../../components/thats/Table'
export default {
    data(){
        return {
            endpoint : 'showrooms/data'
        }
    },
    components: {
        ShowroomsForm,
        ThatsTable
    },

    methods: {
        ...mapActions('ShowroomsModule',[ 'DeleteRecord' ]),
        ...mapMutations('ShowroomsModule',[ 'SetFormRecord', 'SetFormStatusUpdate']),

        formDelete(record){
            const items = [];
            items.push(record.row);
            this.DispatchDelete(items);
        },
        DispatchDelete(items){
            var self = this;
            self.DeleteRecord(items).then((response) => {
                self.$ThatsNotify.success({
                    message : `(${response.deleted}) record was successfully deleted.`
                })
               self.refreshTable();
            })

        },
        OpenUpdateModal(obj){
            this.SetFormStatusUpdate()
            this.SetFormRecord(obj)
            this.openWindow()
        },
        openWindow(){
            this.$refs.dialogForm.openDialog()
        },
        closeWindow(){
            this.$refs.dialogForm.closeDialog()
        },
        refreshTable(){
            this.$refs.table.refreshTable()
        }
    },
    computed: {
        ...mapGetters('ShowroomsModule',[ 'data', 'page', 'total', 'page', 'length', 'columns', 'Loading', ]),
    },
}
</script>
<style scoped>
.container {
    position: relative;
    min-height: 340px;
  }
  .placement {
    position: absolute;
    right: 0;
  }
</style>